import React from 'react';
import './reportProgressBar.scss';

interface ReportProgressBarProps {
    maxValue?: number;
    value: number;
    label: string;
    score?: string;
    hideValue?: boolean;
}

function ReportProgressBar(props: ReportProgressBarProps): JSX.Element {
    const {maxValue = 100, value, label, score, hideValue} = props;

    const percentage = maxValue === 0 ? 0 : Math.min(Math.max((value / maxValue) * 100, 0), 100);
    const truncatedPercentage = Math.round(percentage * 10) / 10; // Round to one decimal place

    return (
        <div className="c-reportProgressBar">
            <div className="c-reportProgressBar__header">
                <div className="c-reportProgressBar__header_label">{`${label} ${!hideValue ? `(${truncatedPercentage}%)` : ''}`}</div>
                <div className={`c-reportProgressBar__header_value c-reportProgressBar__header_value--${hideValue ? 'light' : ''}`}>{`${
                    score || `${value}/${maxValue}`
                }`}</div>
            </div>
            <div className="c-reportProgressBar__progressBar">
                <div className="c-reportProgressBar__progressBar_background" />
                <div className="c-reportProgressBar__progressBar_foreground" style={{width: `${percentage}%`}} />
            </div>
        </div>
    );
}
export default ReportProgressBar;
